import { InjectionToken, Provider } from '@angular/core';

export const WINDOW = new InjectionToken('WINDOW');

export const windowProvider: Provider = {
  provide: WINDOW,
  useValue: window
};
